module.exports = __webpack_public_path__ + "media/MultiAnalysis.6cdf162c.mp4";